import initQuickAddToggle from './product-quickadd-toggle';
import initQuickAddForm from './product-quickadd-form';

const selectors = {
  drawer: '[data-quickadd-drawer]',
};
function initProductQuickAdd() {
  const quickAddDrawer = document.querySelector(selectors.drawer);

  if (!quickAddDrawer) return;

  initQuickAddToggle(quickAddDrawer);
  initQuickAddForm(quickAddDrawer);
}

export default initProductQuickAdd;
